module.exports = __webpack_public_path__ + "static/media/4.13_preview.c21eb7a8.png";